import { render, staticRenderFns } from "./ProjectReportTable.vue?vue&type=template&id=b65a5fba"
import script from "./ProjectReportTable.vue?vue&type=script&lang=js"
export * from "./ProjectReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports